module.exports = "/_next/static/images/e5ae1f7c02fd6d97960f7a93ebfe060b-cartao-proximo-ao-olho-xs@3x.jpg";